// extracted by mini-css-extract-plugin
export default {"title":"Home_title__0Egv-"};